<template>
  <v-row>      
    <div class="col-md-12 home-box">
      <Breadcrumbs :title="'Products'"></Breadcrumbs>
      <ProductGrid></ProductGrid>
    </div>
    <div class="col-md-12 home-tabs-body">
    </div>
  </v-row>
</template>

<script>

import ProductGrid from "@/components/products/ProductGrid";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "Products",
  components: {
    ProductGrid,
    Breadcrumbs
  },
  data: function () {
    return {
    };
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      profile: "profile"
    })
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
  },

  watch: {

  },

  methods: {

  },

};
</script>